import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import NavBar from "@/components/NavBar";
import { useAuth } from "@/lib/auth";
import { formatErr } from "@/lib/api";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await register(email, password, name);
      nav("/onboarding", { replace: true });
    } catch (e) {
      setErr(formatErr(e));
    } finally { setLoading(false); }
  };

  return (
    <div className="App" data-testid="page-register">
      <NavBar />
      <section className="max-w-6xl mx-auto px-6 lg:px-10 py-16 lg:py-24 grid lg:grid-cols-2 gap-16 items-center">
        <div>
          <div className="aa-eyebrow mb-4">Begin your protocol</div>
          <h1 className="font-display text-4xl lg:text-5xl leading-tight">Skincare guidance, <span className="serif-italic">finally</span> calibrated to your phase.</h1>
          <p className="mt-5 text-[var(--aa-text-2)] max-w-md">Free to start. Create your account to save products you analyze and track your protocol over time.</p>
        </div>
        <form onSubmit={submit} className="aa-card p-8 lg:p-10 space-y-5">
          <div>
            <label className="aa-eyebrow block mb-2">Name</label>
            <input data-testid="register-name" type="text" value={name} onChange={(e) => setName(e.target.value)} className="w-full bg-transparent border-b border-[var(--aa-elevated)] focus:border-[var(--aa-text)] outline-none py-3 text-base" placeholder="First name (optional)" />
          </div>
          <div>
            <label className="aa-eyebrow block mb-2">Email</label>
            <input data-testid="register-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-transparent border-b border-[var(--aa-elevated)] focus:border-[var(--aa-text)] outline-none py-3 text-base" />
          </div>
          <div>
            <label className="aa-eyebrow block mb-2">Password</label>
            <input data-testid="register-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-transparent border-b border-[var(--aa-elevated)] focus:border-[var(--aa-text)] outline-none py-3 text-base" placeholder="At least 6 characters" />
          </div>
          {err && <div data-testid="register-error" className="text-sm text-[var(--aa-terra)]">{err}</div>}
          <button data-testid="register-submit" disabled={loading} className="aa-cta-primary w-full">
            {loading ? "Creating account…" : "Create account"}
          </button>
          <div className="text-sm text-[var(--aa-text-3)]">
            Already have an account?{" "}
            <Link to="/login" data-testid="register-to-login" className="underline underline-offset-4">Sign in</Link>
          </div>
        </form>
      </section>
    </div>
  );
}
